<template>
    <div>
        <ul v-if="posts.length">
            <li class="pt-4 text-themeBlackLight" v-for="post in posts" :key="post.id">
                <router-link :to="{ name: 'Post', params: { id: post.id, code: post.code }}">
                    {{ post.name | removeTags }}
                </router-link>
            </li>
        </ul>
        <div class="mt-6" v-else>
            {{getErrorMessage()}}
        </div>
    </div>

</template>


<script>
  export default {
    name: "PostsList",
    data() {
      return {
        posts: [],
      }
    },
    filters: {
      removeTags: function (string) {
        return string.replace(/<\/?[^>]+>/ig, " ");
      }
    },
    methods: {
      getErrorMessage() {
        return this.$store.getters.getTranslation("no_posts");
      },
    },
    mounted() {
      return this.posts = this.$store.getters.getMostPopularPosts.slice(0,4);
    },
  }
</script>

<style scoped>
    li {
        line-height: 1.5em;
    }
</style>
